import type { WhitelabelStoredOnboardingStatus as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';
import * as CloudflareHostnameStatus from './CloudflareHostnameStatus';
import * as DnsRecordCheck from './DnsRecordCheck';

/** One stored onboarding check: the external layers and when it ran, without the overall state. */
export type StoredOnboardingStatus = {
  configId: number;
  checkedAt: string;
  cloudflareHostnames: CloudflareHostnameStatus.CloudflareHostnameStatus[];
  // Empty for a check stored before the backend checked DNS.
  dnsRecords: DnsRecordCheck.DnsRecordCheck[];
};

export const fromGql = (item: GQLItem): StoredOnboardingStatus => ({
  ...take<StoredOnboardingStatus>(item, 'configId', 'checkedAt'),
  cloudflareHostnames: CloudflareHostnameStatus.fromGqlCollection(item.cloudflareHostnames),
  dnsRecords: DnsRecordCheck.fromGqlCollection(item.dnsRecords),
});
